import { render } from "./In.vue?vue&type=template&id=fff0ec6a&scoped=true"
import script from "./In.vue?vue&type=script&lang=js"
export * from "./In.vue?vue&type=script&lang=js"

import "./In.vue?vue&type=style&index=0&id=fff0ec6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff0ec6a"]])

export default __exports__